module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-300.db95b37e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-300.woff2
// module id = 476
// module chunks = 0